import { Box, Card, Skeleton } from '@mui/material';

export const BreakingMarketCardSkeleton = () => {
  return (
    <Card
      sx={{
        p: { xs: 1.5, sm: 2.5 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 } }}>
        {/* Rank skeleton */}
        <Skeleton variant="text" width={24} height={24} />

        {/* Icon skeleton */}
        <Skeleton
          variant="rounded"
          width={56}
          height={56}
          sx={{ borderRadius: 2, flexShrink: 0 }}
        />

        {/* Question + percentage */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="80%" height={24} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width={60} height={20} />
        </Box>

        {/* Change + mini graph + arrow */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, sm: 1.5 },
            flexShrink: 0,
          }}
        >
          <Skeleton variant="text" width={60} height={24} />
          <Skeleton variant="rounded" width={40} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
        </Box>
      </Box>
    </Card>
  );
};

export default BreakingMarketCardSkeleton;
